import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FolderPlus2 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.65313 4.83197C2.65305 4.58394 2.85397 4.38251 3.10317 4.38251H9.66516L11.4268 6.46987C11.5693 6.63872 11.7791 6.73614 12 6.73614H19.8C20.0485 6.73614 20.25 6.93762 20.25 7.18614V9.59999C20.25 10.0142 20.5858 10.35 21 10.35C21.4142 10.35 21.75 10.0142 21.75 9.59999V7.18614C21.75 6.10919 20.877 5.23614 19.8 5.23614H12.3484L10.5867 3.14878C10.4442 2.97993 10.2345 2.88251 10.0136 2.88251H3.10317C2.02654 2.88251 1.15279 3.75462 1.15313 4.83243C1.15342 5.77498 1.15376 7.07661 1.15375 7.9904L1.15366 18C1.15364 19.7397 2.56395 21.15 4.30366 21.15H8.81359C9.2278 21.15 9.56359 20.8142 9.56359 20.4C9.56359 19.9858 9.2278 19.65 8.81359 19.65H4.30366C3.39238 19.65 2.65365 18.9112 2.65366 18L2.65375 7.99041C2.65376 7.07636 2.65342 5.77452 2.65313 4.83197ZM17.55 12C17.55 11.5858 17.2142 11.25 16.8 11.25C16.3858 11.25 16.05 11.5858 16.05 12L16.05 16.05L12 16.05C11.5858 16.05 11.25 16.3858 11.25 16.8C11.25 17.2142 11.5858 17.55 12 17.55L16.05 17.55L16.05 21.6C16.05 22.0142 16.3858 22.35 16.8 22.35C17.2142 22.35 17.55 22.0142 17.55 21.6L17.55 17.55L21.6 17.55C22.0142 17.55 22.35 17.2142 22.35 16.8C22.35 16.3858 22.0142 16.05 21.6 16.05L17.55 16.05L17.55 12Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default FolderPlus2
